import { render, staticRenderFns } from "./sieveSingleHeader.vue?vue&type=template&id=e23e0872&"
import script from "./sieveSingleHeader.vue?vue&type=script&lang=js&"
export * from "./sieveSingleHeader.vue?vue&type=script&lang=js&"
import style0 from "./sieveSingleHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports